import { render, staticRenderFns } from "./binvitation.vue?vue&type=template&id=58665c26&scoped=true&"
import script from "./binvitation.vue?vue&type=script&lang=js&"
export * from "./binvitation.vue?vue&type=script&lang=js&"
import style0 from "./binvitation.vue?vue&type=style&index=0&id=58665c26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58665c26",
  null
  
)

export default component.exports